// Batches and jobs share one status vocabulary, matching the backend PredictionBatchStatus and
// PredictionJobStatus enums.
export type PredictionBatchStatus = 'PENDING' | 'RUNNING' | 'COMPLETED' | 'FAILED';

// Normalizes wire status codes to PredictionBatchStatus. Job status already arrives in that vocabulary;
// batch status still arrives as a pipeline status code (SUCCEEDED, WAITING, BLOCKED) until BNCH-165841.
export const STATUS_CODE_TO_STATUS: Record<string, PredictionBatchStatus> = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  SUCCEEDED: 'COMPLETED',
  WAITING: 'PENDING',
  BLOCKED: 'PENDING',
};

export function isTerminalStatus(status: PredictionBatchStatus): boolean {
  return status === 'COMPLETED' || status === 'FAILED';
}

export type SortField = 'createdAt' | 'modifiedAt' | 'name';
export type SortDirection = 'asc' | 'desc';

export interface SortConfig {
  key: SortField;
  direction: SortDirection;
}

export interface PredictionBatchRow {
  id: string;
  name: string;
  status: PredictionBatchStatus;
  modelName: string;
  creatorName: string;
  createdAt: string;
  modifiedAt: string;
  folderId: string | null;
  folderName: string;
  numPredictionJobs: number | null;
}
